/*
 * A basic module to load the comments and display them in a sortable list
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModule",
  "modules/shared/surveyComments/surveyCommentsView",
  "modules/shared/surveyComments/surveyCommentsModel",
  "modules/shared/redactSurveyCommentModal/redactSurveyCommentModalModule",
], function (
  $,
  Marionette,
  Messenger,
  SortableListModule,
  SurveyCommentsView,
  SurveyCommentsModel,
  RedactSurveyCommentModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "surveyComments";
      this.region = options.region;
    },
    show: function (configBundle) {
      const comments = Messenger.reqres.request(
        "survey:comments",
        configBundle.startDate,
        configBundle.endDate,
        configBundle.touchPoints,
        configBundle.language,
        configBundle.surveyChoice,
        configBundle.topicId,
      );
      const deleteComments = configBundle.deleteComments;
      const extendedEvents = {
        "click #deleteComment": function () {
          const model = this.model;
          Messenger.yesNoDialog("reports.surveyDrilldown.confirmDeleteComment", {
            yes: () => {
              Messenger.vent.trigger("track:interaction", {
                action: "Delete Survey Comment",
                id: model.id,
                idType: "Survey Comment",
                object: "Survey Comment",
                source: "Survey Comments",
              });
              model.destroy();
            },
          });
        },
        "click #redactComment": function () {
          const model = this.model;
          Messenger.vent.trigger("show:modal", RedactSurveyCommentModalModule, {}, model, {
            title: $.t("surveyComments.redactComment.title"),
            trackInteraction: {
              action: "Redact Survey User",
              id: model.id,
              idType: "Survey Comment",
              object: "Survey Comment",
              source: "Survey Comments",
            },
          });
        },
      };

      const headers = Messenger.reqres.request("survey:comments:headers", deleteComments);
      this.layout = new SurveyCommentsView.surveyCommentsView();
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          hideControls: true,
          namespace: this.name,
          extendedEvents: extendedEvents,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this.list.show(comments);
        },
        this,
      );
      this.showRegion(this.layout);
    },
  });
});
